'use client'

import { highlightSearchTerm } from 'highlight-search-term'
import { useEffect } from 'react'
import './HighlightText.css'

export default function HighlightText ({ searchTerm }: { searchTerm?: string }) {
  useEffect(() => {
    let _searchTerm = searchTerm
    if (!searchTerm && window.location.hash.startsWith('#text=')) {
      _searchTerm = decodeURIComponent(window.location.hash.slice('#text='.length))
    }
    if (_searchTerm) {
      highlightSearchTerm({
        search: _searchTerm,
        selector: 'section',
      })
    }
  }, [searchTerm])

  return null
}
